import { render } from "./TestSampleTypeTagNew.vue?vue&type=template&id=1aa2a8aa&scoped=true"
import script from "./TestSampleTypeTagNew.vue?vue&type=script&lang=js"
export * from "./TestSampleTypeTagNew.vue?vue&type=script&lang=js"

import "./TestSampleTypeTagNew.vue?vue&type=style&index=0&id=1aa2a8aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa2a8aa"]])

export default __exports__